import { cliente } from './cliente'
import type {
  Credenciales,
  InscripcionSegundoFactor,
  RespuestaLogin,
  Sesion,
  RespuestaMunicipios,
  RespuestaYo,
} from './modelos'

export async function iniciarSesion(credenciales: Credenciales): Promise<RespuestaLogin> {
  const { data } = await cliente.post<RespuestaLogin>('auth/login', credenciales)

  return data
}

/** El login entrega la sesion, o el desafio del segundo factor (F5-13). */
export function esDesafio(
  respuesta: RespuestaLogin,
): respuesta is Extract<RespuestaLogin, { desafio: string }> {
  return 'desafio' in respuesta
}

export async function inscribirSegundoFactor(desafio: string): Promise<InscripcionSegundoFactor> {
  const { data } = await cliente.post<InscripcionSegundoFactor>('auth/segundo-factor/inscripcion', {
    desafio,
  })

  return data
}

export async function confirmarSegundoFactor(desafio: string, codigo: string): Promise<Sesion> {
  const { data } = await cliente.post<Sesion>('auth/segundo-factor/confirmar', { desafio, codigo })

  return data
}

export async function verificarSegundoFactor(desafio: string, codigo: string): Promise<Sesion> {
  const { data } = await cliente.post<Sesion>('auth/segundo-factor/verificar', { desafio, codigo })

  return data
}

export async function cargarYo(): Promise<RespuestaYo> {
  const { data } = await cliente.get<RespuestaYo>('auth/yo')

  return data
}

/** Cambia la clave propia. El servidor revoca todas las sesiones, incluida la actual. */
export async function cambiarClave(
  email: string,
  claveActual: string,
  claveNueva: string,
  confirmacion: string,
  codigo?: string,
): Promise<void> {
  await cliente.post('auth/cambiar-clave', {
    email,
    clave_actual: claveActual,
    clave_nueva: claveNueva,
    clave_nueva_confirmation: confirmacion,
    ...(codigo ? { codigo } : {}),
  })
}

export async function cerrarSesionEnApi(): Promise<void> {
  await cliente.post('auth/logout')
}

export async function listarMunicipios(): Promise<RespuestaMunicipios> {
  const { data } = await cliente.get<RespuestaMunicipios>('municipios')

  return data
}
